import { Injectable, inject } from '@angular/core';
import { GeoBrowserService } from '@next/arable-lib/geo';
import { Store } from '@ngrx/store';
import { GeoJSON } from 'ol/format';
import { DrawEventType, DrawEvent } from 'ol/interaction/Draw';
import { SiteState } from 'src/app/shared/models';

import { GeoDrawService } from './geo.draw.service';
import { Feature as LocalFeature, InteractionType } from '../../models';
import { FieldOverlapDrawn } from '../../store/actions/feature.actions';

@Injectable({
  providedIn: 'root',
})
export class GeoDrawOverlapService extends GeoDrawService {
  readonly store = inject<Store<SiteState>>(Store);

  interactionTypes = [InteractionType.drawOverlap];

  start(_: GeoBrowserService) {
    this.draw.setActive(true);
    this.layer.setVisible(true);
    this.drawendEventsKey = this.draw.on('drawend' as DrawEventType.DRAWEND, (e: DrawEvent) => {
      this.store.dispatch(
        new FieldOverlapDrawn(new GeoJSON().writeFeatureObject(e.feature) as LocalFeature),
      );
    });
    this.drawstartEventsKey = this.draw.on('drawstart' as DrawEventType.DRAWSTART, () => {
      this.source.clear();
    });
  }
}
